import { Col } from "react-bootstrap";
import "./index.css"
export const SoftwareCard = ({ title, description, imgUrl }) => {
    return (

        <Col size={12} sm={6} md={3}>
            <div className="edu-imgbx">
                <img src={imgUrl} />
                <div className="edu-txtx">
                    <h4>{title}</h4>
                    <span>{description}</span>
                </div>
            </div>
        </Col>

    )
}
